'use strict';



angular.module('myApp.rides', ['ngRoute']).config(['$routeProvider', function($routeProvider) {
	$routeProvider.when('/rides', {
		templateUrl: '/components/rides/rides.html',
		controller: 'ridesCtrl',
		reloadOnSearch: false
	});
	$routeProvider.when('/rides/fares', {
		templateUrl: '/components/rides/fareestimate.html',
		controller: 'fareEstimateCtrl',
		reloadOnSearch: false
	});
	$routeProvider.when('/rides/:city', {
		templateUrl: '/components/rides/ridesCity.html',
		controller: 'ridesCtrl',
		reloadOnSearch: false
	})
    $routeProvider.when('/rides/gurgaon/recommendations', {
        templateUrl: '/components/rides/ridesCityRecommendations.html',
        controller: 'ridesRecommendationCtrl',
        reloadOnSearch: false
    })
	$routeProvider.when('/sg', {
		templateUrl: '/components/rides/taxi_singapore.html',
		controller: 'taxiSingapore',
		reloadOnSearch: false
	})
    
    
    
}]).service('fareestimate', ['$http', '$rootScope', function($http, $rootScope) {
	this.getCityData = function(params) {
		var val = $http({
			method: 'post',
			url: baseUrl_fareestimate + '/get_fare_details_city',
			data: params,
			'headers': {
				'content-type': 'application/x-www-form-urlencoded'
			},
			transformRequest: function(data) {
				return $.param(data);
			}
		});
		return val;
	};
    
    }])
    
    
    
    
    
    
    
    .controller('ridesCtrl', ['$window', '$scope', '$rootScope', 'login', 'ride', '$timeout',
	'$interval', '$location', 'API', '$routeParams','fareestimate','$filter',
	function($window, $scope, $rootScope, login, ride, $timeout, $interval, $location, API, $routeParams,fareestimate,$filter) {




		API.seDefaultData();
		//$scope.counter1 = 913340;
		//$scope.target1 = 17599575;


		//function getMilestoneData(){
		//	return API.get('https://prod-analytics-in.jugnoo.in:8040/jugnoo_big_query_data').then(function(result) {
		//		$scope.counter1 = result.data.Transactions;
		//		$scope.counter2 = result.data.Cities;
		//		$scope.counter3 = result.data.Users;
		//		$scope.counter4 = result.data.drivers;
		//	})
		//}

		//getMilestoneData();
		$scope.counter1 = '29 M';
		$scope.counter2 = '120';
		$scope.counter3 = '8 M';
		$scope.counter4 = '0.1 M';
		$scope.counter5 = '150 M';
        //
		//var updateCounter1 = function() {
        //
		//	if($scope.counter1<$scope.target1)
		//	{
		//		$scope.counter1=$scope.counter1+10000;
		//		$timeout(updateCounter1, 100);
		//	}
		//	else
		//	{
		//		$scope.counter1=$scope.target1;
		//		// console.log($scope.counter);
        //
        //
		//	}
        //
		//};
		//$filter('number')
		//$scope.counter2=1;
		//$scope.target2=39;
        //
		//var updateCounter2 = function() {
        //
		//	if($scope.counter2<$scope.target2)
		//	{
		//		$scope.counter2=$scope.counter2+1;
		//		$timeout(updateCounter2, 3000);
		//	}
		//	else
		//	{
		//		$scope.counter2=$scope.target2;
		//		// console.log($scope.counter);
        //
        //
		//	}
        //
		//};
        //
		//$scope.counter3=11231;
		//$scope.target3=4303595;
        //
		//var updateCounter3 = function() {
        //
		//	if($scope.counter3<$scope.target3)
		//	{
		//		$scope.counter3=$scope.counter3+6243;
		//		$timeout(updateCounter3, 100);
		//	}
		//	else
		//	{
		//		$scope.counter3=$scope.target3;
		//		// console.log($scope.counter);
        //
        //
		//	}
        //
		//};
        //
		//$scope.counter4 = 1231;
		//$scope.target4 = 85351;
        //
		//var updateCounter4 = function() {
        //
		//	if($scope.counter4<$scope.target4)
		//	{
		//		$scope.counter4=$scope.counter4+72;
		//		$timeout(updateCounter4, 100);
		//	}
		//	else
		//	{
		//		$scope.counter4=$scope.target4;
		//		// console.log($scope.counter);
        //
        //
		//	}
        //
		//};

		$scope.scrollTo=function () {
			$('html, body').animate({
				scrollTop: $(".downloadBackground").offset().top - 100
			}, 1000);
		}
		var imgsrc = "images/pressmedia/";
		$scope.pressMediaObject = [
            {
                link:'https://www.forexnewsnow.com/top-stories/interview-samar-singla-jugnoo/',
                desc:"Samar Singla's interview with ForexNewsNow Dubai.",
                img: imgsrc +  'fn_logo.png',
                date:new Date(2019,3,10),

                heading: 'Forex News Now'
            },
            {
                link:'https://timesofindia.indiatimes.com/city/bengaluru/app-based-autorickshaw-services-in-city-help-reduce-dead-mileage/articleshow/68382387.cms',
                desc:"Jugnoo featured in Times of India",
                img: imgsrc + 'toi.png',
                date:new Date(2019,2,13),

                heading: 'The Times of India'
            },
            {
                link:'https://www.entrepreneur.com/article/326185',
                desc:"Samar Singla’s quote in Entrepreneur India story on Why Chandigarh is an Ideal Breeding Ground for Startups?",
                img: imgsrc + 'I_27.png',
                date:new Date(2019,0,12),

                heading: 'Entrepreneur India'
            },
            {
                link:'https://www.tribuneindia.com/news/business/big-boost-to-small-town-dreams/673737.html',
                desc:"Jugnoo has been featured among Chandigarh based startup that managed to Scout funds from MNC’s and other big investors.",
                img: imgsrc +  'ti_logo.jpg',
                date:new Date(2018,9,26),

                heading: 'The Tribune India'
            }
			//{
			//	link:'http://www.htsyndication.com/htsportal/ht-lucknow/article/jugnoo-join-hands-with-larts-to-relaunch-autos/27772225',
			//	desc:"Jugnoo join hands with LARTS to relaunch autos in Lucknow",
			//	img: imgsrc +  'HTSyndication.png',
			//	date:new Date(2018,4,31),
            //
			//	heading: 'HTSyndication'
			//},
			//{
			//	link:'https://techcrunch.com/2018/04/25/jugnoo-singapore-uber-void/',
			//	desc:"India’s Jugnoo adopts a unique take on ride-hailing to help fill Singapore’s Uber void",
			//	img: imgsrc +  'TechCrunch.png',
			//	date:new Date(2018,3,25),
            //
			//	heading: 'Tech Crunch'
			//},
			//{
			//	link:'http://www.businessworld.in/article/Jugnoo-Launches-an-On-demand-3D-Printing-Store-Printo-/26-02-2018-141788/',
			//	desc:"Jugnoo Launches an On-demand 3D Printing Store 'Printo'",
			//	img: imgsrc +  'business_world_logo.png',
			//	date:new Date(2018,1,26),
            //
			//	heading: 'Business World'
			//},
			//{
			//	link:'https://www.youtube.com/watch?v=c46sRt9bAWk',
			//	desc:"ET Now - Leaders of Tomorrow series featuring Jugnoo.",
			//	img: imgsrc +  'ET-Now.jpeg',
			//	date:new Date(2018,1,17),
            //
			//	heading: 'ET Now'
			//},
			//{
			//	link:'https://m.dailyhunt.in/news/india/english/business+sandesh+english-epaper-bussanen/jugnoo+launches+its+business+tools+in+the+auto+expo+2018-newsid-81538255',
			//	desc:"Jugnoo launches its business tools in The Auto Expo",
			//	img: imgsrc +  'daily_hunt.png',
			//	date:new Date(2018,1,10),
            //
			//	heading: 'Daily Hunt'
			//},
			//{
			//	link:'https://www.insightssuccess.in/jugnoo-providing-an-instant-access-to-reliable-and-affordable-service',
			//	desc:"Jugnoo: Providing an Instant Access to Reliable and Affordable Services",
			//	img: imgsrc +  'insights_logo.png',
			//	date:new Date(2018,1),
            //
			//	heading: 'Insights Success'
			//},
			//{
			//	link:'https://www.covaipost.com/coimbatore/3-coimbatore-women-auto-drivers-awarded/',
			//	desc:"Jugnoo women drivers awarded ‘Women of achievement’ by Rotary Club of Monarks, Coimbatore",
			//	img: imgsrc +  'covai_post_logo.png',
			//	date:new Date(2018,0,24),
            //
			//	heading: 'The Covai Post'
			//},
			//{
			//	link:'http://www.businessworld.in/article/Riding-On-India-s-Growth-Wave/18-01-2018-137687/',
			//	desc:"Riding On India’s Growth Wave - Samar Singla’s interview with BW Businessworld.",
			//	img: imgsrc +  'business_world_logo.png',
			//	date:new Date(2018,0,18),
            //
			//	heading: 'Business World'
			//},
            //
			//{
			//	link:'https://in.news.yahoo.com/jugnoo-announces-launch-cabs-chandigarh-113734399.html',
			//	desc:"Jugnoo announces launch of cabs in Chandigarh",
			//	img: imgsrc +  'I_5.png',
			//	date:new Date(2017,11,1),
            //
			//	heading: 'Yahoo News'
			//},
			//{
			//	link:'https://thenortheasttoday.com/arunachal-pradesh-jugnoo-an-auto-hailing-app-gears-up-to-make-inroads-into-northeast-india-through-itanagar/',
			//	desc:"Jugnoo- an auto hailing app gears up to make inroads into Northeast India through Itanagar!",
			//	img: imgsrc + 'tnt-magazine-logon.png',
			//	date:new Date(2017,10,23),
            //
			//	heading: 'The North East Today'
			//}
		]



		//$(window).scroll(function () { // remove "$"
		//	if(window.location.pathname.substring(1) == ""){
		//		var x= $(this).scrollTop();
        //
		//		// console.log(x);
		//		// console.log($('#scroll').offset().top)
        //
		//		if (  x >= $('#scroll').offset().top-($(window).height()+300)){
		//			updateCounter1();
		//			updateCounter2();
		//			updateCounter3();
		//			updateCounter4();
		//		}
        //
		//	}
        //
		//});






		/* $('#myCarousel').carousel({
		 interval: 3500
		 })

		 setTimeout(function(){
		 jQuery("#owlone").owlCarousel({

		 margin:0,
		 autoWidth:true,

		 smartSpeed: 1000,
		 dots:false,
		 mouseDrag: false,
		 touchDrag: false,
		 pullDrag: false,
		 nav:true,


		 navText: ["<img src='images/leftArrow.png'>","<img src='images/slider-arrow.png'>"],


		 })
		 }, 0);*/



		setTimeout( function(){
			jQuery("#owltwo").owlCarousel({

				loop:true,
				margin:0,
				center:true,
				autoplay:true,
				dots:false,

				autoplayTimeout:3000,
				autoplaySpeed:1000,
				autoplayHoverPause:true,
				responsiveClass:true,
				responsive:{
					0:{
						items:2,

					},
					600:{
						items:3,

					},
					1000:{
						items:4,


					},
					1400:{
						items:5,


					}
				}
			})
		}, 0);


		if ($routeParams.city) {
			var cityName = $routeParams.city;
			cityName = cityName.charAt(0).toUpperCase() + cityName.substr(1).toLowerCase();
			$scope.title = 'Jugnoo ' + cityName + ' | Auto Rickshaws Ride starting at Rs 6/km';
			$scope.description = '40% more affordable than cabs and ETA as low as 5 minutes. Book a auto ride now in ' +
				cityName;
			$scope.keywords = 'Auto Rickshaw Ride Online, Auto Ride Online, Jugnoo ' + cityName + ', Auto rickshaw ' +
				cityName;
		} else {
			$scope.title = 'Jugnoo Rides | Affordable Auto Rickshaws online';
			$scope.description = 'Auto Rickshaws 40% more affordable than cabs. Rides starting at Rs. 6/km. Book a ride now.'
			$scope.keywords = 'Auto Rickshaw Ride Online, Auto Ride Online, Jugnoo, cabs online, taxis online'
		}
		
		$window.scrollTo(0, 0);
		clearInterval();
		$scope.bookingError = '';
		$scope.step = 1; //1
		$scope.phoneNumber = '';
		$scope.otp = '';
		$scope.otpError = '';
		$scope.driverEta = '';
		$scope.validLocation = -1; // -1
		$scope.failure = false;
		$scope.cancellationReasons = localStorage.getItem('cancellationReasons') ? JSON.parse(localStorage.getItem(
			'cancellationReasons')) : [];
		$scope.modalStep = 1; //1
		$scope.disableButton = false; //false
		$scope.cancelReason = "";
		$scope.loading = true;
		$scope.cacnelRideMessage = '';
		$scope.hideEta = false;

        $scope.startLat ="";
        $scope.startLong ="";
        $scope.endLat ="";
        $scope.endLng="";

        var count = 0;
		var latitude, longitude;
		var stopTime = null;
		$scope.user = {
			loginUsingOtp: loginUsingOtp,
			verifyOtp: verifyOtp
		};
		$scope.rideFunction = {
			bookRide: bookRide
		}
        $scope.autoCompleteFocusDest=autoCompleteFocusDest;
		/*$scope.autoCompleteFocus=autoCompleteFocus;*/
         $scope.autoCompleteFocusSource=autoCompleteFocusSource;
        $scope.getFareEstimate = getFareEstimate;
         $scope.openPhone = openPhone;
       $scope.fareEstimateFn = fareEstimateFn;
		$scope.clearField = clearField;
		$scope.cancelRequest = cancelRequest;
        $scope.requestRide = requestRide;
		$scope.cancelRide = cancelRide;
		$scope.goFareEstimate = goFareEstimate;
		$scope.cityRide = cityRide;
		$scope.getCities = getCities;
        $scope.getFareDetails = getFareDetails;
        $scope.convertUTCtoIST= convertUTCtoIST;
        var geocoder = new google.maps.Geocoder();
        
        $scope.vehicleTypeAutoPool = false;
			$scope.vehicleTypeBike = false;
			$scope.vehicleTypeAutoNormal = false;
		function cityRide(value) {
			value.city_name = value.city_name.toLowerCase();
			value.city_name = value.city_name.replace(" ", "-")
			if(value && value.city_name == 'singapore')
			{
				$location.path("/sg");
			}
           if (value && value.city_name != 'singapore') {
           	    $location.path("/rides/" + value.city_name);
			
			}
          
			
		}
        
		function getFareDetails(setCityValue) {
            if ($routeParams.city) {
                $scope.vehicleTypeAutoPool = false;
                $scope.vehicleTypeBike = false;
                $scope.vehicleTypeAutoNormal = false;
                var city_name;
                if (setCityValue) {
                    var city_id = setCityValue.city_id;
                }
                var params = {
                    city_id: city_id
                };
                fareestimate.getCityData(params).then(function (response) {
                    var result = response.data;
                    $scope.citySpecificData = result.data[0].customer_fare_details;
                    $scope.referral_info = result.data[0].referral_info;
                    for (var i = 0; i < $scope.citySpecificData.length; i++) {
                        if ($scope.citySpecificData[i].vehicle_type == 2) {
                            $scope.vehicleTypeBike = true;
                            break;
                        }
                    }
                    for (var i = 0; i < $scope.citySpecificData.length; i++) {
                        if ($scope.citySpecificData[i].ride_type == 2 && $scope.citySpecificData[i].vehicle_type == 1) {
                            $scope.vehicleTypeAutoPool = true;
                            break;
                        }
                    }
                    for (var i = 0; i < $scope.citySpecificData.length; i++) {
                        if ($scope.citySpecificData[i].ride_type == 0 && $scope.citySpecificData[i].vehicle_type == 1) {
                            $scope.vehicleTypeAutoNormal = true;
                            break;
                        }
                    }
                });
            }
        }

        	function convertUTCtoIST(time) {
			var hours = parseInt(time.split(':')[0]);
			var minutes = parseInt(time.split(':')[1]);
			hours += 5;
			minutes += 30;
			if (minutes >= 60) {
				hours += 1;
				minutes -= 60;
			}
			if (hours >= 24) hours -= 24;
			return hours.toLocaleString('en-US', {
				minimumIntegerDigits: 2,
				useGrouping: false
			}) + ":" + minutes.toLocaleString('en-US', {
				minimumIntegerDigits: 2,
				useGrouping: false
			}) + ":" + time.split(':')[2];
		}
        
		function getLocation() {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(showPosition);
			}
		}

		function showPosition(position) {
			var mapProp = {
				center: new google.maps.LatLng(position.coords.latitude, position.coords.longitude),
				zoom: 7,
			};
             $scope.onMapIdle = function () {
        google.maps.event.trigger($scope.myMap, 'resize');
        };  
			$scope.startLat = position.coords.latitude;
			$scope.startLong = position.coords.longitude;
			$scope.startLat = parseFloat($scope.startLat);
			$scope.startLong = parseFloat($scope.startLong);
			var map = new google.maps.Map(document.getElementById("map"), mapProp);
			var marker = new google.maps.Marker({
				position: new google.maps.LatLng($scope.startLat, $scope.startLong),
				map: map,
			});
			reverseGeocodeSourceAddress({
				lat: position.coords.latitude,
				lng: position.coords.longitude
			});
		}
        
         function requestRide()
        {
            
               $("#myModal").modal("hide");        
              $("#myModal1").modal("show");
        }
        
        
        function initMap(end_latitude, end_longitude, sourceLat, sourceLng) {
			$scope.end_latitude = parseFloat(end_latitude)
			$scope.end_longitude = parseFloat(end_longitude)
			$scope.sourceLat = parseFloat(sourceLat)
			$scope.sourceLng = parseFloat(sourceLng)
			var directionsDisplay = new google.maps.DirectionsRenderer();
			var directionsService = new google.maps.DirectionsService();
			var map = new google.maps.Map(document.getElementById('map'), {
				zoom: 7,
				center: {
					lat: $scope.sourceLat,
					lng: $scope.sourceLng
				}
			});
			directionsDisplay.setMap(map);
			calculateAndDisplayRoute(directionsService, directionsDisplay);
			var onChangeHandler = function() {
				calculateAndDisplayRoute(directionsService, directionsDisplay);
			};
            google.maps.event.trigger(map, 'resize')
            
			// document.getElementById('mode').addEventListener('change', function () {
			//     calculateAndDisplayRoute(directionsService, directionsDisplay);
			// });
		}
        
         $('#myModal').on('shown.bs.modal', function(){
             
      $scope.fareEstimateFn($scope.endLat, $scope.endLng, $scope.startLat, $scope.startLong);
             initMap($scope.endLat, $scope.endLng, $scope.startLat, $scope.startLong);
    });

		function calculateAndDisplayRoute(directionsService, directionsDisplay) {
			directionsService.route({
				origin: {
					lat: $scope.sourceLat,
					lng: $scope.sourceLng
				}, // Haight.
				destination: {
					lat: $scope.end_latitude,
					lng: $scope.end_longitude
				}, // Ocean Beach.
				// Note that Javascript allows us to access the constant
				// using square brackets and a string value as its
				// "property."
				travelMode: 'DRIVING'
			}, function(response, status) {
				if (status == 'OK') {
					directionsDisplay.setDirections(response);
					// var latlng = [ new google.maps.LatLng(1.23, 4.56),
					//  new google.maps.LatLng(7.89, 1.01)]; 
					//  var latlngbounds = new google.maps.LatLngBounds();
					//  for (var i = 0; i < latlng.length; i++) {
					//      latlngbounds.extend(latlng[i]);
					//     }
					//     map.fitBounds(latlngbounds);
				} else {
					// window.alert('Directions request failed due to ' + status);
				}
			});
		}
       function goFareEstimate()
        {
          $location.path("/rides/fares/"+cityName);
        }
        
        $scope.checkError="";

		function getFareEstimate() {
			if ($scope.endLat && $scope.startLat) {
                 $scope.checkError="";
				/*$scope.fareEstimateFn($scope.endLat, $scope.endLng, $scope.startLat, $scope.startLong);*/
                 $("#myModal").modal("show");
                
			}
            else{
                 $scope.checkError="Please Enter Pickup and Drop Location"
            }
		}
        
        
        function openPhone() {
			if ($scope.endLat && $scope.startLat) {
                 $scope.checkError="";
				$scope.fareEstimateFn($scope.endLat, $scope.endLng, $scope.startLat, $scope.startLong);
                 $("#myModal1").modal("show");
			}
               else{
                 $scope.checkError="Please Enter Pickup and Drop Location"
            }
		}
        
        
        
        function fareEstimateFn(end_latitude, end_longitude, sourceLat, sourceLng) {
			fareestimate.globalReq({
				endpoint: 'fare_estimate',
				start_latitude: sourceLat,
				start_longitude: sourceLng,
				end_latitude: end_latitude,
				end_longitude: end_longitude
			}).then(function(res) {
				// $scope.fareData.fare = res.data.fare.approx_fare;
				$scope.max_fare = res.data.fare.max_fare ? res.data.fare.max_fare : 70;
				$scope.min_fare = res.data.fare.min_fare ? res.data.fare.min_fare : 80;
				$scope.ride_distance = res.data.fare.ride_distance ? res.data.fare.ride_distance : 7;
				$scope.min_ride_time = res.data.fare.min_ride_time ? res.data.fare.min_ride_time : 15;
				$scope.ride_distance_unit = res.data.fare.ride_distance_unit ? res.data.fare.ride_distance_unit :
					'km';
				$scope.ride_time_unit = res.data.fare.ride_time_unit ? res.data.fare.ride_time_unit : 15;
				$scope.approx_fare = res.data.fare.approx_fare;
				 $scope.destLocation = document.getElementById(
				     'destLocSearch').value;
				$scope.validLocation = 1;
				setTimeout(function() {
					$scope.$digest();
				});
			}, function(err) {});
			
		}
        
        function autoCompleteFocusDest() {
            if ($scope.destLocation) {
                setTimeout(function()
                {
					geocoder.geocode({
                    'address': $scope.destLocation,
                	}, function (results, status) {
						$scope.$apply(function () {
							if (status == google.maps.GeocoderStatus.OK) {
								var loc = results[0].geometry.location;
								$scope.endLat = loc.lat();
								$scope.endLng = loc.lng();

								console.log($scope.endLat, $scope.endLng)
								/* $scope.endLat = parseFloat($scope.endLat);
								 $scope.endLng = parseFloat($scope.endLng);*/
							} else {

							}
						})

                	})
				},0)
            }
        }
        
		function autoCompleteFocusSource() {

			if ($scope.sourceLocation) {
                setTimeout(function()
                {

                    geocoder.geocode({
                        'address':$scope.sourceLocation,
                    }, function (results, status) {
                        $scope.$apply(function () {
                            if (status == google.maps.GeocoderStatus.OK) {
                                var loc = results[0].geometry.location;

                                $scope.startLat = loc.lat();
                                $scope.startLong= loc.lng();


                            } else {

                            }
                        })

                    });
				},0)
			}

		}
        
      function reverseGeocodeSourceAddress(position) {
			var geocoder = new google.maps.Geocoder();
			geocoder.geocode({
				'location': position
			}, function(results, status) {
				if (status === 'OK') {
					$scope.sourceLocation = results[0].formatted_address;
					$scope.$digest();
					$("#loaderModal").modal('hide');
				}
			});
		}

		function getCities() {
			$rootScope.loading_custom = true;
			return API.get('https://api-panels.jugnoo.in:8020/get_city_info').then(function(result) {
				var data = result.data;
				$scope.cityList = data.data;
				var cityAdd = ['Ahmedabad','Agartala','Bhopal', 'Bhubaneswar', 'Chandigarh', 'Coimbatore','Faridabad', 'Gurgaon', 'Gwalior', 'Indore', 'Jaipur', 'Jodhpur', 'Kota', 'Mysore', 'Nagpur', 'Nashik', 'Noida', 'Surat','Udaipur', 'Vadodara','Singapore']
				//var cityRemove = ['Amritsar','Ajmer','Dar-es-Salam','Dodoma','Iringa','Kigali','Kuwait City','Mbeya','Zanzibar','Aurangabad','Bareilly','Bhilai','Bathinda','Bengaluru','Chennai','Cuttack','Delhi','Firozabad','Ghaziabad','Gorakhpur','Guwahati','Hyderabad','Itanagar','Jabalpur','Jalandhar','Jamshedpur','Kanpur','Kochi','Kolkata','Kurukshetra','Lucknow','Ludhiana','Madurai','Mangalore','Mumbai','Navi Mumbai','Patiala','Pune','Rajkot','Roorkee','Tiruchirappalli','Vijayawada','Visakhapatnam','Garissa','Malindi','Mwanza','Isiolo','Tanga','DAR-ES-SALAAM','Mombassa','Thika','Zurich','Arusha','Kilifi','Moshi','Nairobi','Eldoret','Kisumu','Nakuru','Muscat']
				for(var val = 0; val< $scope.cityList.length ; val++ )
				{
					if(cityAdd.indexOf($scope.cityList[val].city_name) == -1)
					{
						$scope.cityList.splice(val,1);
						val--;
					}

				}
				var inputCity = $routeParams.city;
				$rootScope.loading_custom = false;
				// var setCityValue = localStorage.getItem('cityNamevalue');
				if (inputCity) {
						inputCity = inputCity.charAt(0).toUpperCase() + inputCity.substr(1).toLowerCase();
						if(inputCity.indexOf("-") > -1)
					    {		
						 	inputCity = inputCity.replace("-", " ");
							inputCity = inputCity.charAt(0).toUpperCase()+inputCity.substr(1,inputCity.indexOf(" ")).toLowerCase()+inputCity.charAt(inputCity.indexOf(" ")+1).toUpperCase() + inputCity.substr(inputCity.indexOf(" ")+2).toLowerCase();
					    } 
					// setCityValue = JSON.parse(setCityValue);
					for (var i = 0; i < $scope.cityList.length; i++) {
						if ($scope.cityList[i].city_name === inputCity) {
							$scope.selectedCity = $scope.cityList[i];
							break;
						}
					}
				}
				/*cityRide($scope.selectedCity);*/
                getFareDetails($scope.selectedCity);
			});
		}
		getCities();

		
		function cancelRequest() {
			$scope.disableButton = true;
			var rideObj = {
				endpoint: 'cancel_ride',
				user_phone: localStorage.getItem('phoneNo'),
				access_token: localStorage.getItem('accessToken'),
				reasons: ""
			};
			ride.globalReq(rideObj).then(function(res) {
				if (res.data.flag == 'SUCCESS') {
					$("#driverModal").modal('hide');
				}
			})
		};

		function cancelRide() {
			var rideObj = {
				endpoint: 'cancel_ride',
				user_phone: localStorage.getItem('phoneNo'),
				access_token: localStorage.getItem('accessToken')
			};
			if ($scope.ride.engagement_id) {
				if ($scope.cancelReason != "") {
					rideObj.reasons = $scope.cancelReason;
					ride.globalReq(rideObj).then(function(res) {
						if (res.data.flag == 'SUCCESS') {
							$("#driverModal").modal('hide');
							$scope.bookingError = '';
							$scope.step = 1;
							$scope.validLocation = 0;
							$scope.modalStep = 1;
							$scope.disableButton = false;
							$scope.cancelReason = "";
						} else {
							$scope.cacnelRideMessage = "Cannot cancel this ride."
						}
					})
				}
			} else {
				ride.globalReq(rideObj).then(function(res) {
					if (res.data.status == 'SUCCESS') {
						$("#driverModal").modal('hide');
						$scope.bookingError = '';
						$scope.step = 3;
						$scope.validLocation = 0;
						$scope.modalStep = 1;
						$scope.disableButton = false;
						$scope.cancelReason = "";
					} else {
						$scope.cacnelRideMessage = "Cannot cancel this ride."
					}
				})
			}
		};
          var timer;
		function bookRide(checkOngoingBooking) {
			if (!checkOngoingBooking) {
				$scope.errFailure = '';
				$scope.cacnelRideMessage = '';
				$scope.modalStep = 1;
				$scope.disableButton = false;
				$('#driverModal').modal({
					backdrop: 'static',
					keyboard: false
				})
			}
			var rideObj = {
				endpoint: 'request_ride',
				latitude: latitude,
				longitude: longitude,
				user_phone: localStorage.getItem('phoneNo'),
				access_token: localStorage.getItem('accessToken')
			};
			if (checkOngoingBooking) {
				rideObj.duplicate_flag =1;
			}
			ride.globalReq(rideObj).then(function(res) {
				if (res.data.flag == 'SUCCESS' && (res.data.ride.status == "ACCEPTED" || res.data.ride.status == "ARRIVED" ||
						res.data.ride.status == "STARTED")) {
					localStorage.setItem('rideData', JSON.stringify(res.data.ride));
					$scope.ride = JSON.parse(localStorage.getItem('rideData'));
					$scope.failure = false;
					$scope.modalStep = 2;
					$scope.hideEta = true;
                    timer = $timeout(function () {
                         bookRide(1);
                        }, 15000);
				} else if (res.data.flag == "SUCCESS" && res.data.ride.status == "COULD_NOT_ASSIGN_DRIVER") {
					$("#driverModal").modal('hide');
					$scope.failure = true;
					$scope.hideEta = false;
					if (!checkOngoingBooking) {
						$scope.errFailure = "No driver is nearby, please try after sometime";
					}
				} else if (res.data.flag == "SUCCESS" && res.data.ride.status == "DENIED") {
					$("#driverModal").modal('hide');
					$scope.hideEta = false;
					$scope.failure = true;
					if (!checkOngoingBooking) {
						$scope.errFailure = "Could Not Assign Any Driver";
					}
				}
			}, function(err) {});
		};

		function clearField() {
			$scope.validLocation = 0;
			document.getElementById('locationSearch').value = ''
		}

        
		function loginUsingOtp(phoneNo) {
			$scope.bookingError = '';
			if (phoneNo == '' || phoneNo == null) {
				$scope.bookingError = "Please enter your phone no. ";
				return false;
			}

			localStorage.setItem('phoneNo', phoneNo);
			login.requestOtp(phoneNo).then(function(res) {
				if (res.data.flag == 'SUCCESS') {
					$scope.bookingError = '';
                     $("#myModal1").modal("hide");
					$scope.step = 2;
				} else if (res.data.flag == "FAILURE") {
					$scope.bookingError = res.data.error;

				}

			}, function() {
				$scope.bookingError = "Some Error occured, please try again";

			})
		}

		function verifyOtp(otp) {
			if (otp == '') return false;
			$scope.otpError = '';
			$rootScope.loading_custom = true;
			var phone = localStorage.getItem('phoneNo');
			login.verifyOtp({
				user_phone: phone,
				login_otp: otp
			}).then(function(res) {
				if (res.data.login.status == 'SUCCESS') {
					localStorage.setItem('accessToken', res.data.login.access_token);
					$scope.cancellationReasons = res.data.login.ride_cancel_reasons_customer;
					localStorage.setItem('cancellationReasons', JSON.stringify(res.data.login.ride_cancel_reasons_customer));
//					getLocation();
//					stopTime = $interval(getLocation, 15000);
                    $scope.fareEstimateFn($scope.endLat, $scope.endLng, $scope.startLat, $scope.startLong);
                    showLocation();
                    $rootScope.loading_custom = false;
				} else if (res.data.login.status == 'LOGIN_FAILURE') {
					$scope.otpError = res.data.login.message;
					$rootScope.loading_custom = false;
				}
			}, function() {
				$scope.otpError = "Some Error occured, please try again";
				$rootScope.loading_custom = false;
			});
		}

		function showLocation() {
			latitude = $scope.startLat;
			longitude = $scope.startLong;
			setTimeout(function() {
				$scope.rideFunction.bookRide(1);
			}, 1000);
			reverseGeocodeSourceAddress({
				lat: $scope.startLat,
				lng: $scope.startLong
			});
			if (count == 0) {
				(function() {
					ride.globalReq({
						endpoint: 'fare_listing',
						latitude: latitude,
						longitude: longitude
					}).then(function(res) {
						$scope.fareData = res.data.fare_details[0];
						$scope.surcharge = res.data.fare_details[0].surcharge[0];
					}, function() {})
				})();
				count++;
			}
			(function() {
				ride.globalReq({
					endpoint: 'find_a_driver',
					latitude: latitude,
					longitude: longitude
				}).then(function(res) {
					$scope.driverEta = res.data.eta;
				}, function() {})
			})();
			$scope.step = 3;
			sessionStorage.setItem('ongoingRide', 'yes');
			$("#loaderModal").modal('hide');
			// $timeout(function () {
			//     getLocation();
			// },15000)
		}


		function errorHandler(err) {
			if (err.code == 1) {
				//@todo show popup to enable location preference
				setTimeout(function() {
					//@todo show popup to enable location preference
					$scope.$digest();
				});
			} else if (err.code == 2) {}
			$("#loaderModal").modal('hide');
		}

		
		$scope.$on("$destroy", function() {
			if (angular.isDefined(timer)) {
				 $timeout.cancel(timer);
				timer=null;
			}
		});
		
	}
                              
]).controller('taxiSingapore', ['$window', '$scope', '$rootScope', 'login', 'ride', '$timeout',
		'$interval', '$location', 'API', '$routeParams','fareestimate',
		function($window, $scope, $rootScope, login, ride, $timeout, $interval, $location, API, $routeParams,fareestimate) {
			$window.scrollTo(0, 0);
			$scope.ContactUsScroll =function () {
				$('html, body').animate({
					scrollTop: (document.body.scrollHeight - 900)
				}, 1000);

			}
			$scope.ContactUsScrollCustomer =function () {
				$('html, body').animate({
					scrollTop: (document.body.scrollHeight - 1400)
				}, 1000);

			}


		}

	])
    .controller('ridesRecommendationCtrl', ['$window', '$scope', '$rootScope',
        function($window, $scope, $rootScope) {
            $window.scrollTo(0, 0);
		}

    ]).service('login', ['$http', '$rootScope', function($http, $rootScope) {
	this.requestOtp = function(reqObj) {
		var val = $http({
			method: 'post',
			url:  rides_baseUrl + '/jugnoo_web_booking',
			data: {
				user_phone: reqObj,
				endpoint: 'generate_login_otp'
			},
			'headers': {
				'content-type': 'application/x-www-form-urlencoded'
			},
			transformRequest: function(data) {
				return $.param(data);
			}
		});
		return val;
	}
	this.tokenLogin = function(reqObj) {
		var val = $http({
			method: 'post',
			url: rides_baseUrl + '/jugnoo_web_booking',
			data: {
				user_phone: localStorage.getItem('phoneNo'),
				access_token: localStorage.getItem('accessToken'),
				endpoint: 'login_using_token'
			},
			'headers': {
				'content-type': 'application/x-www-form-urlencoded'
			},
			transformRequest: function(data) {
				return $.param(data);
			}
		});
		return val;
	}
	this.verifyOtp = function(reqObj) {
		reqObj.endpoint = 'login_using_email';
		var val = $http({
			method: 'post',
			url: rides_baseUrl + '/jugnoo_web_booking',
			data: reqObj,
			'headers': {
				'content-type': 'application/x-www-form-urlencoded'
			},
			transformRequest: function(data) {
				return $.param(data);
			}
		});
		return val;
	}
}]).service('ride', ['$http', '$rootScope', function($http, $rootScope) {
	this.globalReq = function(reqObj) {
		var val = $http({
			method: 'post',
			url: rides_baseUrl + '/jugnoo_web_booking',
			data: reqObj,
			'headers': {
				'content-type': 'application/x-www-form-urlencoded'
			},
			transformRequest: function(data) {
				return $.param(data);
			}
		});
		return val;
	}
}]).service('fareestimate', ['$http', '$rootScope', function($http, $rootScope) {
	this.getCityData = function(params) {
		var val = $http({
			method: 'post',
			url: baseUrl_fareestimate + '/get_fare_details_city',
			data: params,
			'headers': {
				'content-type': 'application/x-www-form-urlencoded'
			},
			transformRequest: function(data) {
				return $.param(data);
			}
		});
		return val;
	}
    
}]).filter('rideStatus', function() {
	return function(val) {
		switch (val) {
			case 'ARRIVED':
				return 'Driver has arrived';
				break;
			case 'STARTED':
				return 'Ride Started';
				break;
			case 'ACCEPTED':
				return 'Driver en route';
				break;
			case 'CANCELLED':
				return 'Driver Denied Duty';
			case 'DENIED':
				return 'Driver Denied Duty';
				break;
			case 'COMPLETED':
				return 'Ride Completed';
			case 'CANCELLED_BY_DRIVER':
				return 'Driver Cancelled Ride'
		}
	};
});